import React from "react";
import "../../App.scss";

function AchievementBadge({
  achievement,
  player,
  alle_turneringer,
  cumScores,
  level,
  achievement_page,
}) {
  const achieved = achievement_page
    ? true
    : player && alle_turneringer && cumScores
    ? achievement.check(player, alle_turneringer, cumScores)
    : false;

  const hemmelig = achievement.secret && !achieved;

  const titleClass = achieved
    ? "achievement-title achieved"
    : "achievement-title";

  return (
    <div key={achievement.title} className={`achievement-element ${achievement.jackpot ? "jackpot" : ""}`}>
      <div className="xptittel">
        <p className="xp">XP: {achievement.xp} {achievement.jackpot && <span className="jackpot-indicator">JACKPOT</span>}</p>
        <p className={titleClass}>{!hemmelig ? achievement.title : "?"}</p>
        {achievement.new && <div className="new-badge"></div>}
      </div>
      <img
        src={achievement.image}
        className={achieved ? "jepp" : "nope"}
        height="64px"
        alt="achievement"
      ></img>
      <p className="achievement-description">
        {!hemmelig ? achievement.description : "Secret until achieved!"}
      </p>
    </div>
  );
}


export default AchievementBadge;
